<template>
	<div class="page-foot-nav-warp">
		<transition name="show-up">
			<div v-if="addInfo" class="add-success-row">
				{{addInfo.product_name}}以加入购物车
			</div>
		</transition>

		<!-- <div  class="add-success-img">
      {{addInfo.product_img}}
      <img v-if="addInfo" :src="addInfo.product_img"/>
    </div> -->


		<div class="foot-nav">
			<!-- 左边 -->
			<div class="left" @click="toShop">
				<div class="label">
					<span class="icon"></span>
					<span>自取门店</span>
				</div>
				<div class="store-name text-ellipsis">{{ store.name }}</div>
				<div class="store-address text-ellipsis">{{ store.address }}</div>
			</div>

			<!-- 右边 -->
			<div class="right-btn" @click="toShoppingCart">
				<div class="price">
					<span v-if="shoppingCartNum > 0">￥{{ price }}</span>
				</div>
				<div class="shopping_bag" v-if="shoppingCartNum == 0">
					<img src="~@/assets/ic_group_order_shopping_bag_empty.png" />
				</div>
				<div class="shopping_bag" v-else>
					<span class="icon">{{ shoppingCartNum }}</span>
					<img src="~@/assets/ic_group_order_shopping_bag_full.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from "vuex";
	import pageevent from "./event";
	import gsap from "gsap";

	export default {
		created() {
			pageevent.$on("addCartSuccess", (d) => {
				this.addInfo = JSON.parse(JSON.stringify(d));
				setTimeout(() => {
					this.addInfo = null;
				}, 2000);
			})
		},
		data() {
			return {
				money: 0,
				addInfo: null
			}
		},
		computed: {
			...mapGetters({
				shoppingCart: "getShoppingCart",
				shoppingCartNum: "getCartNumber",
				store: "getStore",
				total: "gettotal",

			}),
			price() {
				// 检查 this.total 是否存在且包含 total_price 属性
				if (this.total && this.total.total_price !== undefined) {
					return this.total.total_price / 100;
				}
				// 如果 this.total 不存在或 total_price 为空，则检查 this.shoppingCart
				else if (this.shoppingCart && this.shoppingCart.total_price !== undefined) {
					return this.shoppingCart.total_price / 100;
				}
				// 如果两者都不存在或 total_price 为空，则返回默认值（例如 0）
				else {
					return 0; // 或者其他默认值
				}
			}

		},
		watch: {
			price(newValue) {
				gsap.to(this.$data, {
					duration: 0.5,
					money: newValue
				});
			}
		},
		methods: {
			toShop() {
				this.$router.push({
					name: "shop"
				});
			},
			toShoppingCart() {
				this.$router.push({
					name: "shoppingcart"
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.page-foot-nav-warp {
		position: relative;

		.add-success-row {
			position: absolute;
			bottom: 100%;
			height: 70px;
			line-height: 70px;
			padding: 0 30px;
			width: 100%;
			background: #5d5d5d;
			color: #fff;
		}

		.add-success-img {
			width: 80px;
			height: 80px;
			border-radius: 50%;
			position: absolute;
			bottom: 100%;
			right: 20px;
			background: #00af66;

			&::after {
				content: "";
				position: absolute;
				top: 50%;
				left: 0;
				border: 10px solid red;
			}

			img {
				background: #fff;
				width: 60px;
				height: 60px;
				position: absolute;
				left: 50%;
				top: 50%;
				margin-left: -30px;
				margin-top: -30px;
				display: block;
				border-radius: 50%;
			}
		}

		.foot-nav {
			position: relative;
			display: flex;
			background: rgb(40, 40, 40);
			color: #fff;
			overflow: hidden;
			padding: 15px 10px 15px 30px;
			z-index: 10;

			.left {
				flex: 1;
				min-width: 0;
				font-size: 20px;

				.label {
					color: #999;
					margin-bottom: 5px;
					display: flex;
					align-items: center;

					.icon {
						background-image: url(~@/assets/order_icon_map.png);
						background-repeat: no-repeat;
						background-size: contain;
						background-position: center;
						width: 24px;
						height: 26px;
						display: inline-block;
						margin-right: 6px;
					}
				}

				.store-name {
					font-weight: bold;
				}

				.store-address {
					font-size: 24px;
					transform: scale(0.83);
					transform-origin: left;
				}
			}

			.right-btn {
				width: 230px;
				display: flex;
				align-items: flex-end;

				.price {
					flex: 1;
					text-align: right;
					font-size: 32px;
					font-weight: bold;
				}

				.shopping_bag {
					font-size: 0;
					width: 100px;
					height: 100px;
					position: relative;

					.icon {
						position: absolute;
						left: -6px;
						top: 0;
						border-radius: 50%;
						height: 35px;
						min-width: 35px;
						color: #fff;
						background: #00af66;
						font-size: 20px;
						text-align: center;
					}

					img {
						object-fit: contain;
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}

	.show-up-leave-active,
	.show-up-enter-active {
		transition: all 0.3s ease;
	}

	.show-up-enter,
	.show-up-leave-to {
		opacity: 0;
		transform: translateY(100%);
	}
</style>